import FacultyList from "src/pages/Faculty/FacultyList";
import FacultyRegistrationMain from "src/pages/Faculty/FacultyRegistrationMain";

export const facultyRoutes = [
  // faculty
  { path: "/faculty/registration", component: FacultyRegistrationMain },
  { path: "/faculty/list", component: FacultyList },
];
